export default "__VITE_ASSET__BTwfVbqe__"